import classNames from "components/ui/classNames";
import { LinkButton } from "lib/miolo";
import punycode from "punycode";
import { useState } from "react";
import Linkify from "react-linkify";
import { FormattedMessage } from "react-intl";
import getSafeCommentContent from "./getSafeCommentContent";

interface ICommentContentProps {
  bodyAsPlainText: string;
  truncatedCommentLength?: number;
}

export default function CommentContent({ truncatedCommentLength = 600, bodyAsPlainText }: ICommentContentProps) {
  const fullCommentContent = getSafeCommentContent(bodyAsPlainText);
  const truncatedCommentContent = fullCommentContent.slice(0, truncatedCommentLength);

  const [displayingContent, setDisplayingContent] = useState<string>(truncatedCommentContent);

  const hasTruncation = truncatedCommentContent.length !== fullCommentContent.length;
  const isDisplayingTruncatedContent = displayingContent.length !== fullCommentContent.length;

  const urlRegex = /(((https?:\/\/)|(www\.))[^\s]+)/g;
  const contentURLs = fullCommentContent.match(urlRegex);

  return (
    <div className="flex flex-col space-y-3">
      <div
        className={classNames(
          "whitespace-pre-line break-words break-all font-aeonik text-sm font-normal leading-6 tracking-wider text-slate-600",
          "dark:text-slate-300",
        )}
        style={{
          wordBreak: "break-word",
        }}
      >
        <Linkify
          // eslint-disable-next-line react/no-unstable-nested-components
          componentDecorator={(href, text, key) => {
            const matchingURL = contentURLs && contentURLs[key];
            const url = matchingURL && matchingURL.startsWith("www") ? `https://${matchingURL}` : matchingURL;

            const linkText = punycode.toUnicode(text).replace(/^https?:\/\//i, "");
            return (
              <a
                href={punycode.toUnicode(url ?? href)}
                key={key}
                target="_blank"
                rel="noopener noreferrer"
                className="text-blue-700 no-underline visited:text-[#603fa7] hover:underline dark:text-blue-300 dark:visited:text-orange-300"
                style={{
                  wordBreak: "break-word",
                }}
              >
                {linkText.length > 25 ? `${linkText.slice(0, 25)}...` : linkText}
              </a>
            );
          }}
        >
          {isDisplayingTruncatedContent ? `${displayingContent}...` : displayingContent}
        </Linkify>
      </div>
      {isDisplayingTruncatedContent && (
        <div>
          <LinkButton onClick={() => setDisplayingContent(fullCommentContent)}>
            <FormattedMessage defaultMessage="Ver mais" id="rrDco/" />
          </LinkButton>
        </div>
      )}
      {hasTruncation && !isDisplayingTruncatedContent && (
        <div>
          <LinkButton onClick={() => setDisplayingContent(truncatedCommentContent)}>
            <FormattedMessage defaultMessage="Ver menos" id="oqJulP" />
          </LinkButton>
        </div>
      )}
    </div>
  );
}
